import { useQueryClient } from "@tanstack/react-query";
import { useProtectTRPC } from "../trpc";

export function useInvalidateClaims() {
  const trpc = useProtectTRPC();
  const queryClient = useQueryClient();

  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: trpc.claims.list.queryKey() }),
      queryClient.invalidateQueries({
        queryKey: trpc.claims.summary.queryKey(),
      }),
      queryClient.invalidateQueries({
        queryKey: trpc.contracts.list.queryKey(),
      }),
      queryClient.invalidateQueries({
        queryKey: trpc.contracts.search.queryKey(),
      }),
    ]);
}
